
import {
  FETCH_WAITERS_REQUEST,
  FETCH_WAITERS_SUCCESS,
  FETCH_WAITERS_FAILURE,
  CREATE_WAITER_REQUEST,
  CREATE_WAITER_SUCCESS,
  CREATE_WAITER_FAILURE,
  UPDATE_WAITER_REQUEST,
  UPDATE_WAITER_SUCCESS,
  UPDATE_WAITER_FAILURE,
  DELETE_WAITER_REQUEST,
  DELETE_WAITER_SUCCESS,
  DELETE_WAITER_FAILURE,
} from "./waitersActionsType";

const initialState = {
  waiterData: [],
  loading: false,
  error: null,
};

const waiterReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_WAITERS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_WAITERS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        waiterData: action.payload.data,
      };
    case FETCH_WAITERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        waiterData: [],
      };

    case CREATE_WAITER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case CREATE_WAITER_SUCCESS:
      return {
        ...state,
        loading: false,
        waiterData: action.payload.data,
        error: null,
      };
    case CREATE_WAITER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_WAITER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case UPDATE_WAITER_SUCCESS:
      return {
        ...state,
        loading: false,
        waiterData: action.payload.data,
        error: null,
      };
    case UPDATE_WAITER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_WAITER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case DELETE_WAITER_SUCCESS:
      return {
        ...state,
        loading: false,
        waiterData: action.payload.data,
        error: null,
      };
    case DELETE_WAITER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default waiterReducer;
